import { Star, Bike } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { TopBar } from "@/components/Shell";
import { MageCityLogo } from "@/components/Brand";

export default function CourierProfile() {
  const { user, city } = useAuth();
  const v = user?.vehicle || {};
  return (
    <div data-testid="courier-profile-page">
      <TopBar subtitle="Perfil do entregador" />
      <div className="px-4 pt-5">
        <div className="flex items-center gap-4">
          <img
            src="https://images.pexels.com/photos/31635924/pexels-photo-31635924.jpeg?auto=compress&cs=tinysrgb&w=200"
            alt="Motoboy"
            className="w-16 h-16 rounded-2xl object-cover"
          />
          <div>
            <h1 className="font-display text-xl font-extrabold" data-testid="courier-name">{user?.name}</h1>
            <p className="text-xs text-gray-500">{user?.email}</p>
            <p className="text-xs flex items-center gap-1 font-bold mt-1" data-testid="courier-rating">
              <Star size={13} fill="#F5C518" stroke="none" /> {(user?.rating || 5).toFixed(1).replace(".", ",")} de avaliação
            </p>
          </div>
        </div>

        <div className="mt-6 rounded-2xl border border-gray-200 p-4 bg-white" data-testid="vehicle-card">
          <h2 className="font-display font-bold flex items-center gap-2 text-base">
            <Bike size={16} className="text-gf-orange" /> Veículo
          </h2>
          <div className="grid grid-cols-2 gap-y-1 mt-2 text-xs">
            <span className="text-gray-500">Tipo</span><span className="text-right font-semibold">{v.tipo || "Moto"}</span>
            <span className="text-gray-500">Modelo</span><span className="text-right font-semibold">{v.modelo || "—"}</span>
            <span className="text-gray-500">Placa</span><span className="text-right font-semibold">{v.placa || "—"}</span>
            <span className="text-gray-500">Cidade</span><span className="text-right font-semibold">{city?.name || "Magé"}/RJ</span>
            <span className="text-gray-500">Telefone</span><span className="text-right font-semibold">{user?.phone}</span>
          </div>
        </div>

        <div className="mt-8 pt-4 border-t border-dashed flex items-center justify-center gap-3">
          <MageCityLogo size={34} showText={false} />
          <p className="text-[10px] text-gray-400 leading-tight">
            Entregador credenciado<br />Magé Time Food · Prefeitura de Magé
          </p>
        </div>
      </div>
    </div>
  );
}
